import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const WaitlistForm = ({ plan = "Founders Edition", dark = false, compact = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/waitlist", { email, plan });
      setDone(true);
      setEmail("");
      toast.success("You're on the list. Welcome to Stylo.");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const base = dark
    ? "bg-white/10 border-white/20 text-white placeholder:text-white/50 focus:ring-white/60"
    : "bg-white border-stone-200 text-stone-900 placeholder:text-stone-400 focus:ring-stone-900";

  return (
    <form
      onSubmit={submit}
      data-testid="waitlist-form"
      className={`flex flex-col sm:flex-row gap-3 ${compact ? "max-w-md" : "max-w-lg"} w-full`}
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@work.com"
        data-testid="waitlist-email-input"
        className={`flex-1 h-14 px-5 rounded-full border text-base outline-none transition-colors focus:ring-2 ${base}`}
      />
      <motion.button
        type="submit"
        disabled={loading || done}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        data-testid="waitlist-submit-button"
        className="h-14 px-8 rounded-full bg-signal text-white font-semibold text-base flex items-center justify-center gap-2 disabled:opacity-70 transition-colors hover:bg-[#c92d3a] whitespace-nowrap"
        style={{ backgroundColor: "#E63946" }}
      >
        {loading ? (
          <Loader2 className="w-5 h-5 animate-spin" />
        ) : done ? (
          "Reserved \u2713"
        ) : (
          <>
            Reserve yours <ArrowRight className="w-4 h-4" />
          </>
        )}
      </motion.button>
    </form>
  );
};
